let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jGBo1")).then(() => parcelRequire('hPdO5'));